import { render, staticRenderFns } from "./transportg.vue?vue&type=template&id=54fb0970&scoped=true"
import script from "./transportg.vue?vue&type=script&lang=js"
export * from "./transportg.vue?vue&type=script&lang=js"
import style0 from "./transportg.vue?vue&type=style&index=0&id=54fb0970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb0970",
  null
  
)

export default component.exports